import { createContext, useContext } from "react";

const Context = createContext({language: "fr", setLanguage: (lang) => {}})
const useLanguageContext = () => {return useContext(Context);};

export {Context, useLanguageContext }